import { API_BASE_URL } from './api/config';

// Re-export API_BASE_URL for convenient access
export { API_BASE_URL };

export const FILES_ENDPOINTS = {
  list: (parentEntityId?: string) =>
    parentEntityId ? `${API_BASE_URL}/files/list?parentId=${parentEntityId}` : `${API_BASE_URL}/files/list`,
  add: (parentEntityId: string = '-') => `${API_BASE_URL}/files/add`,
  read: (entityId: string, parentEntityId?: string, size?: 'thumbnail' | 'medium' | 'full') => {
    const authToken = localStorage.getItem('authToken') || '';
    const sizeParam = size ? `&size=${size}` : '';
    return `${API_BASE_URL}/files/read/${entityId}?token=${authToken}${sizeParam}`;
  },
  download: (entityId: string) => {
    const authToken = localStorage.getItem('authToken') || '';
    return `${API_BASE_URL}/files/read/${entityId}?token=${authToken}&download=1`;
  },
  /** Dedicated media-streaming URL (used by VideoStudio's preview player).
   *  Redirects to a presigned S3/MinIO URL server-side for native HTTP range
   *  support instead of round-tripping the whole file through backend
   *  memory on every seek — see /api/files/stream in backend/routes/files.py
   *  and VIDEO_STUDIO_ARCHITECTURE.md's "Preview + playback" section. */
  stream: (entityId: string) => {
    const authToken = localStorage.getItem('authToken') || '';
    return `${API_BASE_URL}/files/stream/${entityId}?token=${authToken}`;
  },
  update: (entityId: string, parentEntityId: string = '-') =>
    `${API_BASE_URL}/files/${parentEntityId}/update/${entityId}`,
  delete: (entityId: string, parentEntityId: string = '-') =>
    `${API_BASE_URL}/files/${parentEntityId}/delete/${entityId}`,
};

export const AI_CHAT_ENDPOINTS = {
  sendMessage: () => `${API_BASE_URL}/ai-chat/send-message`,
};

export const CLAUDE_ENDPOINTS = {
  chat: () => `${API_BASE_URL}/claude/chat`,
  chatStream: () => `${API_BASE_URL}/v2/ai/chat/stream`,
  toolOutput: () => `${API_BASE_URL}/claude/tool-output`,
  models: () => `${API_BASE_URL}/claude/models`,
};

export const DOCS_AI_ENDPOINTS = {
  chat: () => `${API_BASE_URL}/docs/chat`,
  detectAI: () => `${API_BASE_URL}/docs/detect-ai-content`,
  detectAIHealth: () => `${API_BASE_URL}/docs/detect-ai-content/health`,
};

export const PDF_ENDPOINTS = {
  enrich: () => `${API_BASE_URL}/enrich_pdf`,
  enrichStatus: () => `${API_BASE_URL}/enrich_pdf/status`,
};

export const PLAID_ENDPOINTS = {
  createLinkToken: () => `${API_BASE_URL}/plaid/create_link_token`,
  exchangePublicToken: () => `${API_BASE_URL}/plaid/exchange_public_token`,
  getAccounts: () => `${API_BASE_URL}/plaid/get_accounts`,
  getItems: () => `${API_BASE_URL}/plaid/get_items`,
  getTransactions: () => `${API_BASE_URL}/plaid/transactions`,
  syncHistorical: () => `${API_BASE_URL}/plaid/sync_historical`,
  getSyncStatus: () => `${API_BASE_URL}/plaid/sync_status`,
};